export default "__VITE_ASSET__d8fd7e8d__"